module.exports = __webpack_public_path__ + "img/16-r.5a29b483.png";